import { useView } from '@hooks';
import React from 'react';
import { IOrderHeaderCardsProps } from './OrderHeaderCards.props';
import { OrderHeaderCardsPresentation } from './OrderHeaderCards.presentation';
import { OrderHeaderCardsMobile } from './OrderHeaderCards.mobile';

export const OrderHeaderCards: React.FC<IOrderHeaderCardsProps> = (props) => {
  const { isMobile } = useView();

  if (isMobile) return <OrderHeaderCardsMobile {...props} />;
  return <OrderHeaderCardsPresentation {...props} />;
};
